import { render, staticRenderFns } from "./patrimonio.vue?vue&type=template&id=7fd4a460&scoped=true&"
import script from "./patrimonio.vue?vue&type=script&lang=js&"
export * from "./patrimonio.vue?vue&type=script&lang=js&"
import style0 from "./patrimonio.vue?vue&type=style&index=0&id=7fd4a460&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd4a460",
  null
  
)

export default component.exports